import utils from '@/mixins/utils.js'

export const dataFields = {
  Profissional: 'no_profissional',
  Nome: 'no_cidadao',
  'Data de nascimento': {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
  'Útimo atendimento covid': {
    field: 'dt_ultimo_atend_covid',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Atendimento: {
    field: 'dt_atendimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Procedimento: {
    field: 'dt_proced_pos_covid',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  'Pós covid': {
    field: 'pos_covid',
    callback: (value) => {
      return value !== '' ? (value === '0' ? 'Não' : 'Sim') : ''
    },
  },
}

export const infoHtml = ''
